







import { defineComponent, computed } from '@vue/composition-api';
import { useLocale } from '../../hooks/useLocale';

export default defineComponent({
  props: {
  },
  setup() {
    const { t } = useLocale();
    const msg = computed<string>(() => t('saas.robotChat.newMessage'));
    return {
      t,
      msg
    };
  }
});
